import { type ComponentPropsWithRef, memo } from 'react';

export const IconDiscover = memo<ComponentPropsWithRef<'svg'>>((props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.7866 2.2136C22.7741 3.20112 23.044 4.71671 22.6276 6.38208L20.1376 16.3221C19.9168 17.2053 19.3707 18.0502 18.7053 18.7155C18.04 19.3809 17.1951 19.927 16.3119 20.1478L6.38173 22.6278C4.71253 23.0437 3.19598 22.7747 2.20923 21.7863C1.22273 20.7982 0.956377 19.2823 1.3724 17.6183L3.8621 7.68946C3.86203 7.68976 3.86218 7.68916 3.8621 7.68946C4.08258 6.80234 4.62558 5.95644 5.29092 5.2911C5.95626 4.62576 6.80127 4.08298 7.68838 3.8625C7.68808 3.86258 7.68868 3.86243 7.68838 3.8625L17.6176 1.3727C19.283 0.956358 20.7991 1.22608 21.7866 2.2136ZM17.9824 2.82766C19.3168 2.4942 20.226 2.77435 20.7259 3.27426C21.2259 3.77424 21.5061 4.68365 21.1724 6.01828L18.6825 15.9579C18.5433 16.5147 18.1693 17.1302 17.6447 17.6548C17.12 18.1795 16.5049 18.5534 15.9481 18.6926L6.01867 21.1724C4.67787 21.5065 3.76902 21.2256 3.27078 20.7265C2.7723 20.2272 2.49365 19.3181 2.82756 17.9823C2.82754 17.9823 2.82758 17.9822 2.82756 17.9823L5.31748 8.0526L5.3179 8.0509C5.45757 7.48834 5.82965 6.87369 6.35158 6.35176C6.87352 5.82982 7.48817 5.45775 8.05072 5.31808L8.05242 5.31766L17.9824 2.82766C17.9826 2.82761 17.9822 2.8277 17.9824 2.82766Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 9.25C10.4812 9.25 9.25 10.4812 9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C13.5188 14.75 14.75 13.5188 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25ZM7.75 12C7.75 9.65279 9.65279 7.75 12 7.75C14.3472 7.75 16.25 9.65279 16.25 12C16.25 14.3472 14.3472 16.25 12 16.25C9.65279 16.25 7.75 14.3472 7.75 12Z"
			fill="#111111"
		/>
	</svg>
));

export const IconDiscoverActive = (props: ComponentPropsWithRef<'svg'>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20.9801 3.01986C20.1101 2.14986 18.8801 1.80986 17.6901 2.10986L7.8901 4.55986C6.2401 4.96986 4.9701 6.24986 4.5601 7.88986L2.1101 17.6999C1.8101 18.8899 2.1501 20.1199 3.0201 20.9899C3.6801 21.6399 4.5501 21.9999 5.4501 21.9999C5.7301 21.9999 6.0201 21.9699 6.3001 21.8899L16.1101 19.4399C17.7501 19.0299 19.0301 17.7599 19.4401 16.1099L21.8901 6.29986C22.1901 5.10986 21.8501 3.87986 20.9801 3.01986ZM12.0001 15.8799C9.8601 15.8799 8.1201 14.1399 8.1201 11.9999C8.1201 9.85986 9.8601 8.11986 12.0001 8.11986C14.1401 8.11986 15.8801 9.85986 15.8801 11.9999C15.8801 14.1399 14.1401 15.8799 12.0001 15.8799Z"
			fill="#111111"
		/>
	</svg>
);
